/* =========== common =========== */
//
export const isMemberFilter = ([groupId, valObj]) => valObj.isMember;
//
export const isOwnerFilter = ([fileId, valObj]) => valObj.isOwner;
//
export const hasMemberFilter = ([userId, isMember]) => isMember;
